interface PageHeaderProps {
  title: string;
  description?: string;
}

export function PageHeader({ title, description }: PageHeaderProps) {
  return (
    <div className="mb-6">
      <h1 className="text-xl font-bold leading-7 text-gray-900 dark:text-theme-dark-text-primary sm:truncate sm:text-2xl sm:tracking-tight">
        {title}
      </h1>
      {description && (
        <p className="mt-2 text-sm text-gray-600 dark:text-theme-dark-text-secondary">
          {description}
        </p>
      )}
    </div>
  );
}
